import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, unref as _unref, createVNode as _createVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, Teleport as _Teleport, openBlock as _openBlock, createBlock as _createBlock, vShow as _vShow, withDirectives as _withDirectives, Transition as _Transition, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  id: "modify-availability-dialog",
  class: "modify-availability-dialog"
}
const _hoisted_2 = { slot: "dialog-header" }
const _hoisted_3 = { slot: "dialog-body" }
const _hoisted_4 = { slot: "bottom-sheet-content" }
const _hoisted_5 = { class: "modify-availability-dialog__bottom-sheet-title" }

import ModifyAvailability from './ModifyAvailability.vue';
    import {onBeforeUnmount, Ref, ref, watch} from 'vue';
    import {storeToRefs} from 'pinia';
    import {pushNotification} from '@malt/joy-entrypoint/src/js/notification';
    import {I18nService} from '@malt/vue3-i18n';

    import {ComponentSelected, useAvailability} from '@/logged/features/header-menu/composables/useAvailability';
    import useDetectOutsideClick from '@/logged/features/header-menu/composables/useDetectOutsideClick';
    import {useDebounce} from '@/logged/common/composables/useDebounce';

    const BREAKPOINT_BOTTOM_SHEET_IN_PX = 767;
    
export default /*#__PURE__*/_defineComponent({
  __name: 'ModifyAvailabilityDialog',
  setup(__props) {

    const availabilityStore = useAvailability();
    const {updateAvailability, updateAvailabilityIsValid, showUpdateAvailabilityDialog} = storeToRefs(availabilityStore);

    const componentSelected: Ref<ComponentSelected> = ref(ComponentSelected.NONE);
    const bottomSheet: any = ref(null);
    const dialog: any = ref(null);
    const dropdown: any = ref(null);
    const showDropdown = ref(false);
    const isCalendarVisible = ref(false);
    let detectClickOutsideActivated = false;

    watch(showUpdateAvailabilityDialog, (test, _) => showDialogOrBottomSheet());

    const {debounce} = useDebounce();

    const debouncedShowDialogOrBottomSheet = () => debounce(showDialogOrBottomSheet, 50);
    window.addEventListener('resize', debouncedShowDialogOrBottomSheet);

    onBeforeUnmount(() => {
        window.removeEventListener('resize', debouncedShowDialogOrBottomSheet);
    });

    function showDialogOrBottomSheet() {
        if (!showUpdateAvailabilityDialog.value.show) {
            return;
        }

        if (window.innerWidth < BREAKPOINT_BOTTOM_SHEET_IN_PX) {
            componentSelected.value = ComponentSelected.BOTTOM_SHEET;
        } else {
            componentSelected.value = showUpdateAvailabilityDialog.value.component;
        }
    }

    watch(componentSelected, (componentSelectedNew, _) => {
        bottomSheet.value.close();
        dialog.value.closeDialog({fireCancelEvent: false});
        showDropdown.value = false;
        detectClickOutsideActivated = false;
        if (componentSelectedNew === ComponentSelected.BOTTOM_SHEET) {
            bottomSheet.value!.openBottomSheet();
        }
        if (componentSelectedNew === ComponentSelected.DIALOG) {
            dialog.value!.openDialog();
        }
        if (componentSelectedNew === ComponentSelected.DROPDOWN) {
            showDropdown.value = true;
            setTimeout(() => (detectClickOutsideActivated = true), 200);
        }
    });

    async function onSubmit() {
        if (!updateAvailabilityIsValid.value) {
            return;
        }
        try {
            await availabilityStore.saveAvailability();
        } catch (error) {
            pushNotification(I18nService.msg('profile.availability.modify.error'), {level: 'error'});
            console.error(error);
            return;
        }
        onClose();
    }

    useDetectOutsideClick(dropdown, () => {
        if (!isCalendarVisible.value && detectClickOutsideActivated && componentSelected.value === ComponentSelected.DROPDOWN) {
            onClose();
        }
    });

    function onClose() {
        componentSelected.value = ComponentSelected.NONE;
        showUpdateAvailabilityDialog.value = {show: false, component: ComponentSelected.NONE};
    }

    function setCalendarVisible(value: boolean) {
        setTimeout(() => (isCalendarVisible.value = value), 200);
    }

    function updateUpdateAvailability(arg: any) {
        updateAvailability.value = {...updateAvailability.value, ...arg};
    }

return (_ctx: any,_cache: any) => {
  const _component_joy_button = _resolveComponent("joy-button")!
  const _component_joy_dialog = _resolveComponent("joy-dialog")!
  const _component_joy_label = _resolveComponent("joy-label")!
  const _component_joy_bottom_sheet = _resolveComponent("joy-bottom-sheet")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_openBlock(), _createBlock(_Teleport, { to: "body" }, [
      _createVNode(_component_joy_dialog, {
        ref_key: "dialog",
        ref: dialog,
        onJoyCancelDialog: onClose
      }, {
        default: _withCtx(() => [
          _createElementVNode("p", _hoisted_2, _toDisplayString(_ctx.$msg('profile.availability.edit.question')), 1),
          _createElementVNode("div", _hoisted_3, [
            _createVNode(ModifyAvailability, {
              "radios-direction": "horizontal",
              state: _unref(updateAvailability),
              showCalendarRelative: true,
              onStateUpdated: updateUpdateAvailability
            }, null, 8, ["state"])
          ]),
          _createVNode(_component_joy_button, {
            slot: "dialog-confirm",
            variant: "main",
            disabled: !_unref(updateAvailabilityIsValid),
            onClick: onSubmit
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_ctx.$msg('navbar.availability.cta.confirm')), 1)
            ]),
            _: 1
          }, 8, ["disabled"])
        ]),
        _: 1
      }, 512)
    ])),
    _createVNode(_Transition, { name: "fade-scale" }, {
      default: _withCtx(() => [
        _withDirectives(_createElementVNode("div", {
          ref_key: "dropdown",
          ref: dropdown,
          class: "availability-dropdown"
        }, [
          _createVNode(_component_joy_label, { class: "availability-dropdown__label" }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_ctx.$msg('profile.availability.edit.question')), 1)
            ]),
            _: 1
          }),
          _createVNode(ModifyAvailability, {
            "radios-direction": "horizontal",
            state: _unref(updateAvailability),
            onCalendarToggled: setCalendarVisible,
            onStateUpdated: updateUpdateAvailability
          }, null, 8, ["state"]),
          _createVNode(_component_joy_button, {
            "data-testid": "navbar-availability-dropdown-confirm",
            variant: "main",
            disabled: !_unref(updateAvailabilityIsValid),
            onClick: onSubmit
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_ctx.$msg('navbar.availability.cta.confirm')), 1)
            ]),
            _: 1
          }, 8, ["disabled"])
        ], 512), [
          [_vShow, showDropdown.value]
        ])
      ]),
      _: 1
    }),
    (_openBlock(), _createBlock(_Teleport, { to: "body" }, [
      _createVNode(_component_joy_bottom_sheet, {
        ref_key: "bottomSheet",
        ref: bottomSheet,
        "close-label": "Confirm",
        "close-variant": "main",
        onJoyBottomSheetClosed: onClose
      }, {
        default: _withCtx(() => [
          _createElementVNode("div", _hoisted_4, [
            _createElementVNode("h2", _hoisted_5, _toDisplayString(_ctx.$msg('profile.availability.edit.question')), 1),
            _createVNode(ModifyAvailability, {
              "radios-direction": "vertical",
              state: _unref(updateAvailability),
              onStateUpdated: updateUpdateAvailability
            }, null, 8, ["state"])
          ]),
          _createVNode(_component_joy_button, {
            slot: "bottom-sheet-cta",
            variant: "main",
            disabled: !_unref(updateAvailabilityIsValid),
            onClick: onSubmit
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_ctx.$msg('navbar.availability.cta.confirm')), 1)
            ]),
            _: 1
          }, 8, ["disabled"])
        ]),
        _: 1
      }, 512)
    ]))
  ]))
}
}

})